import ButtonGroup from 'react-bootstrap/ButtonGroup'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

import Icon from '@/components/Icon/Icon'
import OutboundLink from '@/components/OutboundLink/OutboundLink'
import LinkHelper from '@/components/Panels/LinkHelper/LinkHelper'
import { BRACKETS, bracketsArticleUrl } from '@/utils/constants'
import useDirectories from '@/utils/useDirectories'

import styles from './NavigationPanel.module.scss'

type Props = {
  bracket?: string
  budget?: string
  sanitized_wo?: string
  tag?: string
}

const NavigationPanelBracket = ({ bracket, sanitized_wo }: Props) => {
  const { dir } = useDirectories()
  const linkPrefix = `/${dir}/${sanitized_wo}`
  // Have to disable this for now cause it can lead to 404s
  //const linkSuffix = `${tag ? `/${tag}` : ''}${budget ? `/${budget}` : ''}`
  const linkSuffix = ``
  return (
    <div>
      <div className={styles.navigationTitle}>
        Bracket
        <OutboundLink className={styles.icon} url={bracketsArticleUrl}>
          <OverlayTrigger
            overlay={
              <Tooltip>
                <div>
                  <b>Commander Brackets</b> is a matchmaking system
                </div>
                <div>being tested by Wizards of the Coast.</div>
                <div>
                  Click the <Icon icon='circleQuestion' size='sm' /> to learn more.
                </div>
              </Tooltip>
            }
            placement='bottom'
          >
            <span className={styles.tooltipIcon}>
              <Icon icon='circleQuestion' size='lg' />
            </span>
          </OverlayTrigger>
        </OutboundLink>
      </div>
      <ButtonGroup className={styles.navigationButtons} size='sm'>
        <LinkHelper href={linkPrefix + linkSuffix} primary={bracket === undefined} scroll={false}>
          All
        </LinkHelper>
        {BRACKETS.map((bracketType, i) => (
          <LinkHelper
            href={`${linkPrefix}/${bracketType}${linkSuffix}`}
            key={bracketType}
            primary={bracket === bracketType}
            scroll={false}
          >
            {i + 1}
          </LinkHelper>
        ))}
      </ButtonGroup>
    </div>
  )
}

export default NavigationPanelBracket
